import intro from '@/lib/apiDocTemplates/introduction';
import formatting from '@/lib/apiDocTemplates/formatting';
import parameters from '@/lib/apiDocTemplates/parameters';
import limits from '@/lib/apiDocTemplates/limits';
import services from '@/lib/apiDocTemplates/services';
import demo from '@/lib/apiDocTemplates/demo';

const sections = [intro, formatting, parameters, limits, services, demo];

export default {

  state: {
    activeSection: 0
  },

  getters: {
    getAPISections: state => () => {
      return sections;
    },
    getActiveSection: state => index => {
      return index ? state.activeSection : sections[state.activeSection];
    }
  },

  mutations: {
    setAPISection(state, sec){
      state.activeSection = sec;
    }
  },

  actions: {
    updateAPISection(context, sec){
      context.commit('setAPISection', sec);
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/apiDocs.js